import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { BUYCOURSE } from '../../Routes/RouteConstent';
import parse from 'html-react-parser';

const MembershipDetail = ({ data, handleNext, type, earlySubscribeAsyncState }: any) => {
    let tax = 0;
    let Navigate = useNavigate()
    let [calculationTax, setCalculationTax] = useState<number>(data?.amount ? Number(data?.amount) * tax / 100 : 0)
    const [finalAmt, setFinalAmt] = useState(0)

    const updateFinalAmt = (amount:number) => setFinalAmt(+amount.toFixed(2));
    const updateCalculationTax = (amount:number) => setCalculationTax(+amount.toFixed(2));

    const finalAmount = () => {
        if (type === "member") {
            data?.price_deduction ? updateFinalAmt((Number(data?.price_deduction) * tax / 100) + Number(data?.price_deduction)) :
                updateFinalAmt((Number(data?.amount) * tax / 100) + Number(data?.amount))
        } else {

            updateFinalAmt((Number(data?.amount) * tax / 100) + Number(data?.amount))
        }
    }
    const taxCalculateFun = () => {
        updateCalculationTax(Number(data?.amount) * tax / 100)
    }
    useEffect(() => {

        finalAmount();
    }, [])


    let handlePayment = () => {
        if (type === "course") {
            let obj = {
                course_id: data?.id,
                tax,
                amount: data?.amount,
                total_amount: finalAmt,
                tax_amount: calculationTax,
                data
            }
            Navigate(BUYCOURSE, { state: { obj } })

        } else {
            let amt;
            if (data?.price_deduction) {
                amt = data?.price_deduction;
            } else {
                amt = data.amount;
            }
            let obj = {
                amount: amt,
                total_amount: finalAmt,
                tax,
                membership_id: data.id,
                tax_amount: calculationTax,
            }

            handleNext(obj)
        }
    }


    return (
        <div>
            <div>
                
                <div className="step-innercontent detail-step4">
                    <div>
                        <h3>{type === "member" ? "Membership" : "Course"} <span className="strong">Details</span></h3>
                        {
                            data.id === 2 && <p>
                                As part of our Nurture Guarantee, if after your Welcome Call and
                                one course, you don’t find the resources you’re looking for,
                                we’ll refund you in full.*
                            </p>
                        }
                        <div className="inner-monthdiv membership-details-main">
                            <div className='monthly-membership'>
                                <div className='payment-details' style={{ border: `1px solid ${data?.color_code}` }}>
                                    <div className="monthbox">
                                        <div className='monthbox-head' style={{ backgroundColor: `${data?.color_code}` }}>
                                            <div className='d-flex justify-content-start justify-content-md-between align-items-center membership-nm flex-column flex-md-row' >
                                                <h4>{data?.title} Membership</h4>
                                                <div className="d-flex justify-content-end Plan-price flex-column">
                                                    <div>
                                                        {/* <span className="pCost-old">${data?.base_price} </span> */}
                                                        {/* <span className="pCost">${type === "member" ? data?.price_deduction ? data?.price_deduction : data?.amount : data?.amount} </span><span className="membership-cycle">{type === "member" && "/mo"}</span> */}
                                                        <span className="pCost">${type === "member" ? data?.amount : data?.amount} </span><span className="membership-cycle">{type === "member" && "/mo"}</span>
                                                    </div>
                                                    <div>
                                                        {type === "member" ? <p className='text-end m-0 p-0 white'>{data?.sub_title}</p> : ""}
                                                    </div>
                                                </div>
                                                {/* <p className="pricepara">${data?.amount}</p> */}
                                            </div>
                                        </div>

                                        <div className='monthbox-details'>
                                            <p>{parse(String(data?.description))}</p>
                                        </div>

                                        {/* <h4>{data?.title}</h4>
                                        <p className="pricepara">${data?.amount}</p> */}
                                        {/* <p>Monthly access to our members-only classes, Q&As, nursing forum and more! You will be charged $97 each month for access to our full membership program and all member perks.
                                        Enjoy special discounts on lactation and sleep consults. This subscription renews every month.</p> */}
                                        {/* <p>{data?.description}</p> */}
                                    </div>
                                </div>
                                <div className="bill-details" style={{ border: `1px solid ${data?.color_code}` }}>
                                    <h6 style={{ backgroundColor: `${data?.color_code}` }}>Billing Details</h6>
                                    <ul className="first">
                                        <li>
                                            <span className="headingspan">{type !== "course" ? "Consult" : "Course"}  Total</span>
                                            <span className="pricespan">${type === "member" ? data?.price_deduction ? data?.price_deduction : data?.amount : data?.amount}</span>
                                        </li>
                                        <li className="inner-spans">
                                            <span>Taxes & Charges</span>
                                            <span>+${calculationTax}</span>
                                        </li>
                                    </ul>
                                    <ul className="pay-list">
                                        <li>
                                            <span className="payspan">Total:</span>
                                            <span className="pay-total">${finalAmt}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        className="btn primary-blue-btn mt-5 mb-5"
                        disabled={earlySubscribeAsyncState?.pending}
                        onClick={handlePayment}
                        style={{ backgroundColor: `${data?.color_code}` }}
                    >
                        {earlySubscribeAsyncState?.pending ? (
                        <CircularProgress size={30} />
                        ) : (
                        "Confirm & Pay"
                        )}
                    </button>

                    {
                        data.id === 2 && <p className='mb-4'>
                            Refunds will be provided with no questions asked for those parents who have done a welcome call and have not utilized the discount code or welcome perks for past or future services.*
                        </p>
                    }
                </div>
            </div>
        </div>
    )
}

export default MembershipDetail